

!(function () {

    var x = document.querySelector('.c-three-level-navigation');
    var y = document.querySelector('.c-mobilebar__descriptor');
    if (x) {
        x.remove();
    }
    if (y) {
        y.remove();
    }

    if ((location.origin + location.pathname).includes(getBaseUrl(document.currentScript.src))) {
        return;
    }

    var appElement = document.querySelector('claims-root');
    if(!(appElement instanceof HTMLElement)){
        return;
    }
    
    document.aemPath = window.location.pathname;
    document.aemIntegrationAppClaimType = appElement.dataset.type;
    document.aemIntegrationAppServerURL = getBaseUrl(document.currentScript.src, document.aemIntegrationAppClaimType);


    readJson(document.aemIntegrationAppServerURL + document.aemIntegrationAppClaimType + '/sources.json');

    integrity = '?' + (function (domain) {
        var numHash = 0;

        if (0 === domain.length) {
            return numHash;
        }

        for (var r = 0; r < domain.length; r++) {
            numHash = (numHash << 5) - numHash + domain.charCodeAt(r);
            numHash &= numHash;
        }

        return numHash;
    })(window.location.protocol + window.location.host);

    var originResource = null;
    var scriptRegexPattern = /<script.*?src="(.*?)"/;
    var isParsed = false;

    function readJson(url) {
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error("HTTP error " + response.status);
                }
                return response.json();
            })
            .then(json => {
                if (initSources(json, document.aemIntegrationAppClaimType)) {
                    !location.hash.split('/').includes(document.aemIntegrationAppClaimType) ?
                        location.hash += document.aemIntegrationAppClaimType + '/' : null;
                }
            })
            .catch(function () {
                this.dataError = true;
            });
    }

    function validateSource(sourceUrl) {
        var baseUrl = (function () {

            if (isParsed) {
                return originResource;
            }

            if (document.aemIntegrationAppServerURL) {
                originResource = document.aemIntegrationAppServerURL;
            }

            if (!originResource) {
                originResource = getBaseUrl(document.currentScript.getAttribute('src'), document.aemIntegrationAppClaimType);
            }

            if ('./' === originResource) {
                originResource = void 0;
            }

            if (originResource) {
                document.aemIntegrationAppServerURL = originResource;
            }

            isParsed = true;
            return originResource;

        })();

        if (baseUrl && sourceUrl.indexOf('/') === -1) {
            return (baseUrl + sourceUrl).replace(/([^:]\/)\/+/g, '$1');
        }

        return (sourceUrl).replace(/([^:]\/)\/+/g, '$1');
    }

    function getBaseUrl(src, type = undefined) {
        if (type) {
            return src.substring(0, src.lastIndexOf(type));
        }
        return src.substring(0, src.lastIndexOf('/')) + '/';
    }

    function initSources(json, type) {
        var readyCss = false;
        var readyJs = false;
        if (json['css'][type] !== undefined) {
            json['css'][type].forEach(function (value) {
                if (value != 'favicon.ico') {
                    var linkTag = document.createElement('link');
                    linkTag.rel = 'stylesheet';
                    linkTag.href = document.aemIntegrationAppServerURL + validateSource(value),
                        document.head.appendChild(linkTag);
                }
            });
            readyCss = true;
        }

        if (json['js'][type] !== undefined) {
            json['js'][type].forEach(function (value) {
                var newScriptTag = document.createElement('script');
                newScriptTag.src = document.aemIntegrationAppServerURL + validateSource(value);
                newScriptTag.async = false;
                newScriptTag.defer = false;
                newScriptTag.type = "module";
                document.body.appendChild(newScriptTag);
            });
            readyJs = true;
        }

        return readyCss && readyJs;
    }
})();